import React from 'react';

// Styles & Assets
import styles from './MedicineAdmin.module.css';
import { FaCheck } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';

// Interfaces
import { DrugOption } from '../../../interfaces/Drug';
import TakenOptions from '../TakenOptions/TakenOptions';
import NonTakenOptions from '../NonTakenOptions/NonTakenOptions';

const MedicineAdmin: React.FC<{
    drugOption: DrugOption
    handleChangeDrugOption: (optionAttributes: Partial<DrugOption>) => void
}> = ({ drugOption, handleChangeDrugOption }) => {

    return (
        <>
            <p className={styles.drugName}>{drugOption.drugName}</p>
            <div className={styles.selectors}>
                <div className={styles.buttonsContainer}>
                    <button
                        onClick={() => handleChangeDrugOption({ taken: true })}
                        className={`button ${drugOption.taken === true ? styles.check : styles.notSelected}`}
                    >
                        <FaCheck />
                    </button>
                    <button
                        onClick={() => handleChangeDrugOption({ taken: false })}
                        className={`button ${drugOption.taken === false ? styles.cross : styles.notSelected}`}
                    >
                        <ImCross />
                    </button>
                </div>
                {drugOption.taken ?
                    <TakenOptions
                        professionalAdmin={drugOption.professionalAdmin}
                        counter={drugOption.counter}
                        handleChangeCounter={(counter: number) => handleChangeDrugOption({ counter })}
                        handleChangeAdmin={() => handleChangeDrugOption({ professionalAdmin: !drugOption.professionalAdmin })}
                    />
                    :
                    <NonTakenOptions
                        forgotten={drugOption.forgotten}
                        handleSetForgotten={(forgotten: boolean) => handleChangeDrugOption({ forgotten })}
                        defaultComment={drugOption.comment}
                        handleChangeComment={(comment: string) => handleChangeDrugOption({ comment })}
                        small
                    />
                }
            </div>
        </>
    );
};

export default MedicineAdmin;